import { useEffect } from 'react';

import { pharmacyActions, resetStatus, successOrSelector } from '@pharmaplan/common';
import strings from '../../localization';
import useCancellationBooking from '../useCancellationBooking';
import useUpdateBookedTiming from './useUpdateBookedTiming';
import { Constants } from '../../helpers/Constants';
import useSelfService from '../useSelfService';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

const {
  variant: { text },
} = Constants;

const useBookedProfileActions = (id: string) => {
  const dispatch = useAppDispatch();
  const { isSelfService } = useSelfService();

  const {
    showCancelConfirmation,
    handleCancelConfirmation,
    handleSelfCancellation,
  } = useCancellationBooking();

  const {
    show,
    formikHandleSubmit,
    handleDiscardUpdated,
    confirmAction,
    dateTime,
    showUpdateTimingSuccessModal,
    getPharmacist,
  } = useUpdateBookedTiming(id);

  const updateTimingsSuccess = useAppSelector((state) =>
    successOrSelector([pharmacyActions.updateTimings], state));

  const selfCancellation = () => {
    handleSelfCancellation(id);
  };

  const handleActions = () => {
    if (show) {
      return {
        primaryButton: {
          label: strings.saveChanges,
          onClick: formikHandleSubmit,
        },
        secondaryButton: {
          label: strings.discardChanges,
          variant: text,
          onClick: handleDiscardUpdated,
        },
      };
    }
    return {
      primaryButton: {
        label: strings.updateTiming,
        onClick: confirmAction,
      },
      secondaryButton: {
        label: strings.cancelBooking,
        variant: text,
        onClick: selfCancellation,
      },
    };
  };

  const handleCancellation = () =>
    ({
      primaryButton: {
        label: '',
        onClick: null,
      },
      secondaryButton: {
        label: strings.cancelBooking,
        variant: 'text' as const,
        onClick: () => {
          showCancelConfirmation(id, handleCancelConfirmation);
        },
      },
    });

  useEffect(() => {
    if (updateTimingsSuccess) {
      showUpdateTimingSuccessModal();
      handleDiscardUpdated();
      getPharmacist();
      dispatch(resetStatus());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTimingsSuccess]);

  return {
    bookingActions: isSelfService ? handleActions : handleCancellation,
    dateTime,
  };
};

export default useBookedProfileActions;
